import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'treeview',
  templateUrl: './treeview.component.html',
  styleUrls: ['./treeview.component.scss']
})
export class TreeviewComponent implements OnInit {

  @Input() nodes: Array<any>;
  @Output() onCheckNode = new EventEmitter();
  @Output() itemSelected: EventEmitter<IItemTreeView>;
  @Output() selectedNode: EventEmitter<IItemTreeView>;

  constructor() {
    this.selectedNode = new EventEmitter<IItemTreeView>();
    this.itemSelected = new EventEmitter<IItemTreeView>();
   }

  ngOnInit() {
  }

  ngOnChanges() {
  }

  onSelectedNode(node: IItemTreeView) {
    this.selectedNode.emit(node);
  }
  
  onEmitCheck(node) {
    this.itemSelected.emit(node);
  }

}